import { render, staticRenderFns } from "./gramdetails.vue?vue&type=template&id=77b4e706&scoped=true"
import script from "./gramdetails.vue?vue&type=script&lang=js"
export * from "./gramdetails.vue?vue&type=script&lang=js"
import style0 from "./gramdetails.vue?vue&type=style&index=0&id=77b4e706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4e706",
  null
  
)

export default component.exports